module.exports = __webpack_public_path__ + "img/009-perspective.4edfbd28.svg";